import React from 'react'

import {
  allowNumericOnly,
  numberWithCommas,
  numberAddCommas,
  numberClearCommas,
  presenceErrorClass,
} from 'servos/formValidations'

class CurrencyInput extends React.Component {

  onChange = (e) => {
    this.props.onChange(numberClearCommas(e.currentTarget.value))
  }

  renderInput() {
    const {
      size,
      defaultValue,
      errorMessage,
      placeholder,
      readOnly,
    } = this.props;

    if ( readOnly == true ) {
      return(
        <input
          value={ numberAddCommas(defaultValue) }
          className={ `form-control ${classes.control[size]} ${presenceErrorClass(errorMessage)}` }
          placeholder={ placeholder || '' }
          readOnly={ readOnly }
          inputMode='numeric'
        />
      )
    } else {
      return(
        <input
          value={ numberAddCommas(defaultValue) }
          onKeyPress={ allowNumericOnly }
          onKeyUp={ numberWithCommas }
          className={ `form-control ${classes.control[size]} ${presenceErrorClass(errorMessage)}` }
          onChange={ this.onChange }
          placeholder={ placeholder || '' }
          readOnly={ readOnly }
          inputMode='numeric'
        />
      )
    }
  }
  render() {
    const {
      append,
      errorMessage,
    } = this.props;

    return(
      <div className={`input-group ${classes.input[append]}`}>
        <div className="input-group-prepend">
          <div className={ `input-group-text ${presenceErrorClass(errorMessage)}` }>
            $
          </div>
        </div>
        { this.renderInput() }
        {this.props.children}
        <div className="invalid-feedback">
          { errorMessage }
        </div>
      </div>
    )
  }
}

const classes = {
  control: {
    large: 'form-control-lg',
    withSelect: 'form-control col-6 aria-label',
  },
  input: {
    helptext: 'input-group-append-helptext'
  }
}

export default CurrencyInput;
